import {Injectable} from "@angular/core";
import {ToastController, Platform} from "ionic-angular";
import {Toast} from "@ionic-native/toast";


@Injectable()
export class ToastService {

 constructor(private webToast: ToastController, private platform: Platform, private nativeToast: Toast){}

 show(message, duration = '4000', position = 'bottom'){
   return this.platform.ready().then(() => {

     if(this.platform.is('cordova')){
       return this.nativeToast.show(message, duration, position)
         .subscribe();
     }else{
       let toast = this.webToast.create({
         message: message,
         duration: parseInt(duration)
       });
       return toast.present();
     }
   });
 }


}



// WEBPACK FOOTER //
// ./src/app/core/toast.service.ts